<template>
  <form-panel
    width="medium"
    title="Crear campaña"
    @closePanel="closeModal">
    <div class="content-campaign" >
      <div
        class="option-campaign"
        @click="showCampaignCreate">
        <i
          :class="{'isValidate':stateCampaign }"
          class="icon-check-circle"/>
        <div class="title">
          <p>Nombra la campaña</p>
          <span>Crea la campaña a enviar</span>
        </div>
      </div>
      <div
        class="option-campaign"
        @click="showCampaignAssign">
        <i
          :class="{'isValidate':stateListEmail}"
          class="icon-check-circle"/>
        <div class="title">
          <p>¿A quien?</p>
          <span>A quien le vamos a enviar la campaña.</span>
        </div>
      </div>
      <div
        class="option-campaign"
        @click="showCampaignSubject">
        <i
          :class="{'isValidate' : stateSubject}"
          class="icon-check-circle"/>
        <div class="title">
          <p>Asunto</p>
          <span>Cual es el asunto para esta campaña.</span>
        </div>
      </div>
      <div
        class="option-campaign"
        @click="showCampaignMail">
        <i
          :class="{'isValidate':stateContent}"
          class="icon-check-circle"/>
        <div class="title">
          <p>Contenido</p>
          <span>Diseña tu email</span>
        </div>
      </div>
    </div>
    <div class="footer">
      <h4 v-if="messageShow">¡Tu campaña esta lista para editar!</h4>
      <h4 v-else>¡Tu campaña ya casi está lista!</h4>
      <div class="logo">
        <img
          src="~@/assets/mail-campaing.svg"
          alt="AGCO">
      </div>
      <div class="options-mail">
        <el-button
          v-loading.fullscreen.lock="fullscreenLoading"
          class="send"
          @click="onSaveContent">Enviar a revisión</el-button>
      </div>
    </div>
    <campaign-create-panel
      v-if="modalCampaignCreate"
      :campaign="campaign"
      @onSendCampaign="onSendCampaign"/>
    <campaign-assign-panel
      v-if="modalCampaignAssign"
      :message="oldMessage"
      @sendListCustomers="onSendListCustomers"/>
    <campaign-subject-panel
      v-if="modalCampaignSubject"
      :message="oldCampaignContent"
      @sendSubject="onSendSubject"/>
    <campaign-email-panel
      v-if="modalCampaignMail"
      :message="oldCampaignContent"
      @onSendContent="onSendContent"/>
  </form-panel>
</template>

<script>
import CampaignAssignPanel from '@/modules/campaigns/campaign-assign-panel'
import CampaignSubjectPanel from '@/modules/campaigns/campaign-subject-panel'
import CampaignEmailPanel from '@/modules/campaigns/campaign-email-panel'
import CampaignCreatePanel from '@/modules/campaigns/campaign-create-panel'
import FormPanel from '@/components/_shared/form-panel'
import moment from 'moment'
export default {
  name: 'CampaignCreateView',
  components: {
    FormPanel,
    CampaignAssignPanel,
    CampaignSubjectPanel,
    CampaignEmailPanel,
    CampaignCreatePanel
  },
  props: {
    old: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      oldMessage: {},
      oldCampaignContent: {},
      campaignContent: {},
      campaign: {},
      message: {},
      stateCampaign: false,
      stateSubject: false,
      stateListEmail: false,
      stateContent: false,
      fullscreenLoading: false,
      messageShow: false
    }
  },
  computed: {
    modalCampaignAssign () {
      return this.$store.getters['app/showCampaignAssignPanel']
    },
    modalCampaignSubject () {
      return this.$store.getters['app/showCampaignSubjectPanel']
    },
    modalCampaignMail () {
      return this.$store.getters['app/showCampaignMailPanel']
    },
    modalCampaignCreate () {
      return this.$store.getters['app/showCampaignCreatePanel']
    }
  },
  mounted () {
    if (this.old !== null) {
      let promises = []
      promises.push(this.$store.dispatch('messages/query', {
        'filters[where][campaignId][eq]': this.old.id}))
      promises.push(this.$store.dispatch('campaignContents/query', {
        limit: 1000,
        'filters[where][campaignId][eq]': this.old.id}))
      Promise.all(promises)
        .then(data => {
          this.oldMessage = data[0].data.items[0] ? data[0].data.items[0] : {}
          this.oldCampaignContent = {}
          for (let i = 0; i < data[1].data.items.length; i++) {
            if (this.old.id === parseInt(data[1].data.items[i].campaignId)) {
              this.oldCampaignContent = data[1].data.items[i]
            }
          }
          this.stateCampaign = true
          this.stateSubject = true
          this.stateListEmail = true
          this.stateContent = true
          this.messageShow = true
        }).catch(e => {
          this.$emit('closeCampaign', true)
          this.toggleCampaignPanel()
        })
    }
  },
  methods: {
    closeModal () {
      this.messageShow = false
      this.$emit('closeCampaign', true)
      this.toggleCampaignPanel()
    },
    showCampaignAssign () {
      if (this.stateCampaign) {
        this.$store.dispatch('app/toggleCampaignAssignPanel')
      } else {
        this.$message.error('Debe crear una campaña para asignar un destinatario')
      }
    },
    showCampaignSubject () {
      if (this.stateListEmail) {
        this.$store.dispatch('app/toggleCampaignSubjectPanel')
      } else {
        this.$message.error('Debe de asignar un destinatario antes de crear el asunto')
      }
    },
    showCampaignMail () {
      if (this.stateSubject) {
        this.$store.dispatch('app/toggleCampaignMailPanel')
      } else {
        this.$message.error('Debes de asignar un asunto antes de crear el email')
      }
    },
    showCampaignCreate () {
      if (this.old !== null) {
        this.campaign = this.old
      }
      this.$store.dispatch('app/toggleCampaignCreatePanel')
    },
    showCampaignEdit () {
      this.$store.dispatch('app/toggleCampaignEditPanel')
    },
    toggleCampaignPanel () {
      this.$store.dispatch('app/toggleCampaignPanel')
    },
    onSendCampaign (data) {
      this.campaign = data
      this.stateCampaign = true
    },
    onSendListCustomers (list) {
      if (typeof list === 'object') {
        delete this.oldMessage.emails
        this.oldMessage.emails = list
      }
      if (typeof list === 'number') {
        this.oldMessage.customerGroupId = list
      }
      if (list !== null || list !== undefined) {
        if (Array.isArray(list)) {
          this.message.emails = list
        } else {
          this.message.customerGroupId = list
        }
        this.stateListEmail = true
      }
    },
    onSendSubject (subject) {
      this.oldCampaignContent.subject = subject.subject
      if (subject !== {}) {
        this.campaignContent.subject = subject.subject
        this.stateSubject = true
      }
    },
    onSendContent (content) {
      this.oldCampaignContent.banner = content.nameImg
      this.oldCampaignContent.content = content.content
      this.campaignContent.content = content.content
      this.campaignContent.banner = content.nameImg
      this.stateContent = true
    },
    onSaveContent () {
      if (this.old !== null) {
        let copyMessage = JSON.parse(JSON.stringify(this.old))
        delete copyMessage.created
        const idCampaign = copyMessage.id
        this.campaign = copyMessage
        if (this.message.emails) {
          this.message.emails = this.message.emails.length > 0 ? this.message.emails : this.oldMessage.emails
        } else {
          this.message.customerGroupId = this.message.customerGroupId ? this.message.customerGroupId : this.oldMessage.customerGroupId
        }
        this.message.campaignId = idCampaign
        this.message.id = this.oldMessage.id

        this.campaignContent.banner = this.campaignContent.length > 0 ? this.campaignContent.banner : this.oldCampaignContent.banner
        this.campaignContent.content = this.campaignContent.length > 0 ? this.campaignContent.content : this.oldCampaignContent.content
        this.campaignContent.subject = this.campaignContent.length > 0 ? this.campaignContent.subject : this.oldCampaignContent.subject
        this.campaignContent.campaignId = idCampaign
        this.campaignContent.id = this.oldCampaignContent.id

        let promises = []
        promises.push(this.$store.dispatch('campaigns/save', this.campaign))
        promises.push(this.$store.dispatch('messages/save', this.message))
        promises.push(this.$store.dispatch('campaignContents/save', this.campaignContent))
        Promise.all(promises)
          .then(data => {
            this.$notify({
              title: 'Success',
              message: 'La campaña fue actualizada correctamente.',
              type: 'success'
            })
            this.messageShow = false
            this.$emit('closeCampaign', true)
            this.toggleCampaignPanel()
          })
          .catch(e => {
            this.$message.error('La campaña no pudo ser creada, vuelva a intentarlo')
          })
          .finally(() => {
            if (this.$route.name === 'campaigns-list-recent') {
              this.$store.dispatch('campaigns/query', {
                limit: 10,
                'filters[whereBetween][startDate]': [moment().format('YYYY-MM-DD'), moment().add(1, 'day').format('YYYY-MM-DD')]
              })
            } else {
              this.$store.dispatch('campaigns/query', {sort: 'createdAt DESC'})
            }
          })
      } else {
        if (Object.keys(this.message).length !== 0 &&
            Object.keys(this.campaignContent).length !== 0 &&
            Object.keys(this.campaign).length !== 0) {
          this.$store.dispatch('campaigns/save', this.campaign)
            .then(data => {
              this.message.campaignId = data.data.id
              this.campaignContent.campaignId = data.data.id
              let promises = []
              promises.push(this.$store.dispatch('messages/save', this.message))
              promises.push(this.$store.dispatch('campaignContents/save', this.campaignContent))
              Promise.all(promises)
                .then(data => {
                  this.$notify({
                    title: 'Success',
                    message: 'La campaña fue creada correctamente.',
                    type: 'success'
                  })
                  this.messageShow = false
                  this.$emit('closeCampaign', true)
                  this.toggleCampaignPanel()
                })
                .catch(e => {
                  this.$message.error('La campaña no pudo ser creada, vuelva a intentarlo')
                })
                .finally(() => {
                  if (this.$route.name === 'campaigns-list-recent') {
                    this.$store.dispatch('campaigns/query', {
                      limit: 10,
                      'filters[whereBetween][startDate]': [moment().format('YYYY-MM-DD'), moment().add(1, 'day').format('YYYY-MM-DD')]
                    })
                  } else {
                    this.$store.dispatch('campaigns/query', {sort: 'createdAt DESC'})
                  }
                })
            })
            .catch(e => {
              this.$message.error('La campaña no pudo ser creada, vuelva a intentarlo')
            })
        } else {
          this.$message.error('Verifique si los datos se han completado')
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .error{
  color: $primary;
    font-weight: bold;
  }
.content-campaign{
  padding: 0 30px;
  height: 60vh;
  position: relative;
  overflow: auto;
  .option-campaign{
    margin: 0 -30px;
    border-top: 1px solid $border-primary;
    height: 95px;
    display: flex;
    align-items: center;
    &:hover{
      cursor: pointer;
    }
    &:last-child{
    border-bottom: 1px solid $border-primary;
    }
    .title {
      p{
        @include font-lato(13px, bold);
        color: #3E3E3E;
      }
      span{
        @include font-primary(13px, regular);
        color: #707070;
      }
    }
    i{
      margin: 15px;
      font-size: 18px;
    }
  }
  .isValidate{
      color: $success;
      font-weight: 500;
  }
}
.footer{
  display: flex;
  flex-direction: column;
  align-items: center;
  h4{
    margin: 0 0 15px 0;
  }
  .logo{
    width: 100px;
    height: 100px;
    margin-bottom: 20px;
  }
  .options-mail{
    .cancel{
      border: none;
    }
    .send{
      background-color: $primary  ;
      color: #ffffff;
      border: none;
      box-shadow: 0 3px 6px 0 rgba(231, 18, 14, 0.5);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/app/campaigns/campaign-create-view.vue